import { customerFilterOptions } from './options';
import { Country } from './options/country';
import { Marketplace } from './options/marketplace';
import { State } from './options/state';
import { Tag } from './options/tag';

const popularOrdersFiltersIds = ['marketplaceUsernames', 'country', 'state', 'tag'];

export const popularFilterByOptions = [Marketplace, Country, State, Tag];

export const otherFilterByOptions = customerFilterOptions.filter((option) => !popularOrdersFiltersIds.includes(option.id));
